import { useNavigate } from "flemo";
import { LoaderCircleIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useAuthStore } from "@/store/authStore";

export function DeleteAccountDialog() {
  const { replace } = useNavigate();
  const user = useAuthStore(state => state.user);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const deleteAccount = useAuthStore(state => state.deleteAccount);

  async function handleDeleteAccount(): Promise<void> {
    if (!user) {
      return;
    }

    setIsDeletingAccount(true);

    try {
      await deleteAccount();
      await replace("/login", {}, { transitionName: "none" });
    } catch {
      toast.error("계정 삭제에 실패했어요. 다시 시도해 주세요.", { richColors: true, position: "top-center" });
    } finally {
      setIsDeletingAccount(false);
    }
  }

  return (
    <div className="flex justify-center mt-auto pt-10">
      <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
        {/* 계정 삭제 버튼 */}
        <DialogTrigger className="text-sm text-muted-foreground underline-offset-4 cursor-pointer">
          계정 삭제
        </DialogTrigger>

        {/* 계정 삭제 모달 */}
        <DialogContent>
          <DialogHeader>
            <DialogTitle>정말 탈퇴하시겠어요?</DialogTitle>
            <DialogDescription>
              계정을 삭제하면 모든 학습 데이터가 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="border-t-0 bg-transparent">
            <Button
              type="button"
              variant="destructive"
              size="lg"
              onClick={() => void handleDeleteAccount()}
              disabled={isDeletingAccount}
              className="w-full sm:w-auto"
            >
              {isDeletingAccount && <LoaderCircleIcon className="size-4 animate-spin" />}
              탈퇴하기
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
